import { Suspense, useState } from "react";
import { breadcrumbActualizacionDeuda } from "../utils/BreadcrumbItem";
import { Box, Paper } from "@mui/material";
import { FiltrosComponent, TablaComponent } from "../components";
import { FormFiltersActualizacionInterface } from "../interfaces";
import Breadcrumb from "../../../../components/ui/materialui/breadcrumb";

interface Props {};

const ActualizacionDeuda: React.FC<Props> = ({}: Props) => {
    
    const [formFilters, setFormFilters] = useState<FormFiltersActualizacionInterface & { trigger: number }>({
        rutCliente: '',
        idSolicitud: '',
        idOperacion: '',
        nombreNuevoProveedor: '',
        rutNuevoProveedor: '',
        trigger: 0
    });

    const handleFilters = (formFilters: FormFiltersActualizacionInterface) =>
        setFormFilters(prev => ({ ...formFilters, trigger: prev.trigger + 1 }));

    return (
        <Suspense>
            <Breadcrumb items={ breadcrumbActualizacionDeuda } />
            <Box sx={{ mt: 2 }}>
                <Paper elevation={3} sx={{ p: 3 }}>
                    <Suspense>

                        <FiltrosComponent handleFilters={handleFilters} />

                        { formFilters.idOperacion.trim().length > 0 && 
                            <TablaComponent
                                key={formFilters.trigger}
                                formFilters={formFilters}
                            /> 
                        }

                    </Suspense>
                </Paper>
            </Box>
        </Suspense>
    );
}

export default ActualizacionDeuda;